(() => {
  const initialize = (root) => {
    if (!root || root.dataset.replicaReady === 'true') return;
    root.dataset.replicaReady = 'true';
    const gallery = root.querySelector('[data-product-gallery]');
    const slides = gallery ? [...gallery.querySelectorAll('[data-gallery-slide]')] : [];
    const dots = [...root.querySelectorAll('[data-gallery-dot]')];
    const setActiveDot = (index) => dots.forEach((dot, dotIndex) => {
      const active = dotIndex === index;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-current', active ? 'true' : 'false');
    });
    const goTo = (index) => {
      if (!gallery || !slides.length) return;
      const target = (index + slides.length) % slides.length;
      gallery.scrollTo({ left: slides[target].offsetLeft, behavior: 'smooth' });
      setActiveDot(target);
    };
    if (gallery && slides.length > 1) {
      let ticking = false;
      gallery.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          const index = Math.round(gallery.scrollLeft / Math.max(gallery.clientWidth, 1));
          setActiveDot(Math.max(0, Math.min(index, slides.length - 1)));
          ticking = false;
        });
      }, { passive: true });
      root.querySelector('[data-gallery-prev]')?.addEventListener('click', () => {
        const current = Math.round(gallery.scrollLeft / Math.max(gallery.clientWidth, 1));
        goTo(current - 1);
      });
      root.querySelector('[data-gallery-next]')?.addEventListener('click', () => {
        const current = Math.round(gallery.scrollLeft / Math.max(gallery.clientWidth, 1));
        goTo(current + 1);
      });
      dots.forEach((dot) => dot.addEventListener('click', () => goTo(Number(dot.dataset.galleryDot))));
    }
    const variantInput = root.querySelector('[data-replica-variant-id]');
    root.querySelectorAll('[data-replica-variant-choice]').forEach((choice) => choice.addEventListener('click', () => {
      root.querySelectorAll('[data-replica-variant-choice]').forEach((button) => button.classList.toggle('is-selected', button === choice));
      if (variantInput) variantInput.value = choice.dataset.variantId;
      const price = choice.dataset.price;
      const compare = choice.dataset.compare || price;
      const available = choice.dataset.available === 'true';
      root.querySelectorAll('[data-replica-current-price]').forEach((node) => { node.textContent = price; });
      root.querySelectorAll('[data-replica-compare-price]').forEach((node) => { node.textContent = compare; node.hidden = compare === price; });
      root.querySelectorAll('[data-replica-atc]').forEach((button) => {
        button.disabled = !available;
        button.textContent = available ? `Add to Bag · ${price}` : 'Sold Out';
      });
    }));
  };
  const boot = (scope = document) => scope.querySelectorAll('[data-replica-product]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot()); else boot();
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
